// noteSearchReducer.js noteSearch
import { createSlice } from '@reduxjs/toolkit';

const initialState = { // Initial state
  noteSearchString: '',
  confirmedNoteSearchString: '',
  noteSearchStringClearButton: false,
  showRemainingNoteSearch: false,
  searchCriteriaListItem2: null,
  searchResultVerseList2: { ResultTotal: -1, VerseList: [] },
  pageNumberNoteSearch: -1,
  searchHttpPostData2: null,
  //loading4Search2: false,
  verseListItem2: {},
  noteSearchStringPlaceHolder: '',
};

const noteSearchSlice = createSlice({ // Create the slice
  name: 'noteSearch', // Slice name
  initialState,
  reducers: {
    setNoteSearchString(state, action) { state.noteSearchString = action.payload },
    setConfirmedNoteSearchString(state, action) { state.confirmedNoteSearchString = action.payload },
    setNoteSearchStringClearButton(state, action) { state.noteSearchStringClearButton = action.payload },
    setShowRemainingNoteSearch(state, action) { state.showRemainingNoteSearch = action.payload },
    setSearchCriteriaListItem2(state, action) { state.searchCriteriaListItem2 = action.payload },
    setSearchResultVerseList2(state, action) { state.searchResultVerseList2 = action.payload },
    setPageNumberNoteSearch(state, action) { state.pageNumberNoteSearch = action.payload },
    //setSearchHttpPostData2(state, action) { state.searchHttpPostData2 = action.payload },
    //setLoading4Search2(state, action) { state.loading4Search2 = action.payload },
    setVerseListItem2(state, action) { state.verseListItem2 = action.payload },
    setNoteSearchStringPlaceHolder(state, action) { state.noteSearchStringPlaceHolder = action.payload },
    reset4NoteSearch() { return initialState },
  },
});

export const { setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch } = noteSearchSlice.actions;
export default noteSearchSlice.reducer; // Export the reducer